import { Field, FieldProps } from 'formik';
import { FormattedMessage } from 'react-intl';
import { Locale } from '@synergy/models';
import { PoolTextField } from '@synergy/components';

import { useAppSelector } from '../../../store/use-appstate-selector';

interface ConfigurationTranslationsFieldProps {
    locale: Locale;
    autoFocus?: boolean;
    fieldName?: string;
    required?: true | false | 'locale';
}

export const ConfigurationTranslationsField = (props: ConfigurationTranslationsFieldProps) => {
    const currentLocale = useAppSelector(state => state.currentLocale);
    const { locale, fieldName = 'translations', autoFocus, required = 'locale' } = props;

    return (
        <Field name={`${fieldName}.${locale}`}>
            {({ field, meta }: FieldProps<string>) => (
                <PoolTextField
                    {...field}
                    value={field.value ?? ''}
                    fullWidth={true}
                    label={<FormattedMessage id={`app.common.${locale}`} />}
                    error={meta.touched && !!meta.error}
                    helperText={meta.touched && meta.error ? <FormattedMessage id={meta.error} /> : null}
                    required={required === 'locale' ? locale === currentLocale : required}
                    autoFocus={autoFocus}
                />
            )}
        </Field>
    );
};
